import Entity from "./entity";

class Product extends Entity {
  constructor(data) {
    super(data);

    this.label = this.label  || null;
    this.shelfLife = this.shelfLife  || null;
    this.shortDescription = this.shortDescription  || null;
    this.validFrom = !!this.validFrom ? this.convertDate(this.validFrom).startOf('d') : null;
    this.validTo = !!this.validTo ? this.convertDate(this.validTo).endOf('d') : null;

    this.value = this.id;
  }

  get valid() {
    return !this.validTo || this.validTo.isSameOrAfter();
  }
}

export default Product;



// WEBPACK FOOTER //
// ./client/domain/product.js